export const AUTH_KEY = "loginV2";

export const AUTH_COOKIE_EXPIRY_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export const SSR_EVENTS_ID = 513998242;
